import { IHesapBilgileri } from "./finance.model";

export interface IDaireBorcAlacak extends IHesapBilgileri {
    mulkiyetDurumu: string;
    bolumID: number;
    blokID: number;
    eposta: string;
    telefon: string;
}

export interface IDaireBorcAlacakBlok {
    blokID: number;
    blokNo: string;
}
export interface IDaireBorcAlacakBolum {
    blokID: number;
    bolumID: number;
    bolumNo: string;
}
export class DaireBorcAlacakFilter {
    adiSoyadi: string;
    blokID: number;
    bolumID: number;
    durum: boolean;
}

export enum EFilterPage {
    blok = 1,
    bolum = 2,
}